// src/Demos/CompoundInterestDemo.js
import React from "react";
import CoordinatePlane from "../MathTools/CoordinatePlane";

export default function CompoundInterestDemo({
  principal = 1000,
  rate = 0.05,
  years = 10,
  width = 400,
  height = 300
}) {
  // Build lines array => each circle at (year, value)
  const lines = [];
  let maxVal = 0;

  for (let y = 0; y <= years; y++) {
    const val = principal * Math.pow(1 + rate, y);
    if (val > maxVal) maxVal = val;

    lines.push({
      start: [y, val],
      end: [y, val],
      color: "blue",
      label: `Year ${y}: $${val.toFixed(2)}`
    });
  }

  // Domain
  const xDomain = [0, years + 1]; 
  const yDomain = [0, maxVal * 1.1];

  // Build an x‐axis tick array: [0,1,2,...,years+1]
  const xTickValues = [];
  for (let i = 0; i <= years + 1; i++) {
    xTickValues.push(i);
  }

  // Optionally, create a yTick array in, say, $500 increments
  // so you get 0, 500, 1000, 1500, etc. up to just above maxVal.
  const yTickValues = [];
  const step = 500; // or 100, or 1000
  let curr = 0;
  while (curr <= (maxVal * 1.1 + step)) {
    yTickValues.push(curr);
    curr += step;
  }

  return (
    <div style={{ margin: "1em 0" }}>
      <h5>Compound Interest (Lump Sum) Demo</h5>
      <CoordinatePlane
        width={width}
        height={height}
        showAxes={true}
        axisMode="border"
        disablePlot={true}
        lines={lines}
        xDomain={xDomain}
        yDomain={yDomain}
        xTickValues={xTickValues}
        yTickValues={yTickValues}
        style={{ margin: "0 auto", display: "block" }}
      />
      <p style={{ fontSize: "1.1em", fontStyle: "italic", marginTop: 8 }}>
        Plot shows principal growing from $ {principal} at {(rate*100).toFixed(1)}%
        annually for {years} years.
      </p>
    </div>
  );
}
